import { api } from 'shared/api';

import { UpdateJobPreferencesPayload } from './types';

export async function updateJobPreferences(payload: UpdateJobPreferencesPayload) {
    return await api.put('candidatePortal/candidates/JobPreferences', payload);
}
